import { axios } from '../util/axios'

const API_ENDPOINT = '/captain-marvel/v1/sessions/my'

export const getSessions = () =>
  axios.get(API_ENDPOINT, {}, { withCredentials: true }).then(response => response.data)

export const deleteSessions = () =>
  axios
    .delete(API_ENDPOINT, {}, { withCredentials: true })
    .then(response => response.status > 199 && response.status < 400)
    .catch(e => (e.status > 399 && e.status < 500 ? false : e))
